module.exports = __webpack_public_path__ + "static/16-57a63fee63b3e53d7b6c8fcbb9315008.jpg";